var emailPatternRegExp =  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

var RecoveryPasswordModel = Backbone.Epoxy.Model.extend({
  /**
   * Initialize this model.
   *
   * You must keep the `Backbone.Validation.bind` call if you want this model to have validation.
   */
  initialize: function() {
    Backbone.Validation.bind(this, {liveValidation: true});
  },
  
  computeds: {
    hasErrorMessage: {
      get: function() {
        return this.get('errorMessage') !== '';
      }
    },
    hasSuccessMessage: {
      get: function() {
        return this.get('successMessage') !== '';
      }
    }
  },

  defaults: {
    email: '',
    errorMessage: '',
    successMessage: '',
    recoverText: 'Recover Password',
    recoveringText: 'Sending recover email...',
    isProcessing: false
  },

   validation: {
     email: [
       {
         fn: function (value) {
           var el = $("#insertYourEmail");
           if (!value) {
             if (el) el.attr("aria-invalid", "true");
             return 'Please enter your email address.';
           }
           if (!emailPatternRegExp.test(value)) {
             if (el) el.attr("aria-invalid", "true");
             return 'Please enter valid email address.';
           }
           if (el) el.attr("aria-invalid", "false");
         }
       }
     ]
   }
});

module.exports = RecoveryPasswordModel;
